import { initNewRelic } from "./index";

initNewRelic();
